import styled from 'styled-components'
import Button from '../Button'
import Input from '../Input'
import { colors } from '../../constants'

const StyledButton = styled(Button)`
    font-size: 0.6em;
    margin-right: 0 !important;
`

export const Label = styled.span`
    outline: none;

    ${({ onClick }) =>
        onClick &&
        `
    cursor: pointer;
    transition: margin 0.3s;
    position: relative;

    &:hover {
      opacity: 0.6;
      margin-right: 1.2em;
    }
  `}
`

export const StyledInput = styled(Input)`
    font-size: inherit;
`

export const ButtonSave = styled(StyledButton)`
    border-radius: 0;
`

export const ButtonCancel = styled(StyledButton)`
    border-radius: 0 5px 5px 0;
    color: ${colors.red};
`

export const ButtonEdit = styled(StyledButton)`
    padding: 0.3em 0.6em;
    position: absolute;
    opacity: 0;
    top: 0;
    transition: all 0.3s;
    transform: translateX(-50%);

    *:hover > & {
        opacity: 1;
        transform: translateX(0);
    }
`
